export const AUTH_TOKEN = 'auth_token';
export const REG_TOKEN = 'reg_token';
export const TOKEN = localStorage.getItem(AUTH_TOKEN);